import React from 'react';
import CommonPage from './CommonPage';
const Delivery = () => {
  return (
    <CommonPage title="ডেলিভারি সেবা">
      আমাদের ডেলিভারি সেবা সম্পর্কে বিস্তারিত শীঘ্রই জানানো হবে।
    </CommonPage>
  );
};
export default Delivery;
